import { Profile, ProfileConfig } from '@foxcorp/foxkit-profile-js';

import { getUiConfig } from '@/config/client/getUiConfig';

import { configOptions } from './configOptions';
import { statefulRefreshToken } from './statefulRefreshToken';

const uiConfig = getUiConfig();

const profileConfig = new ProfileConfig({
  ...configOptions,

  environment: uiConfig.environmentAlt,
  useEksEndPoints: true,

  statefulRefreshToken,
});

console.debug('[profileSDK]', { profileConfig, env: uiConfig.environmentAlt });

export const profileSDK = new Profile(profileConfig);
